import type { SipEngineOverview } from '@sbclite/core/container/api'

export function observedInterfaceLabel(interfaces: SipEngineOverview['observed']['interfaces']): string {
  if (interfaces === null) return 'Not reported by engine'
  if (interfaces.length === 0) return 'Reported none'
  return `${interfaces.length} reported interface${interfaces.length === 1 ? '' : 's'}`
}

export function observedMediaLabel(mediaRealm: SipEngineOverview['observed']['mediaRealm']): string {
  return mediaRealm === null ? 'Not reported by engine' : mediaRealm.name ?? mediaRealm.id ?? 'Reported without identity'
}

export function interfaceTruncationWarning(truncated: boolean, source: 'saved' | 'observed'): string | null {
  return truncated ? `${source === 'saved' ? 'Saved' : 'Engine-reported'} interface list truncated; not all entries are shown.` : null
}

export function observedAudioPortLabel(mediaRealm: SipEngineOverview['observed']['mediaRealm']): string {
  return mediaRealm === null || mediaRealm.audioPort === null ? 'Not reported' : String(mediaRealm.audioPort)
}

export function observedHeartbeatLabel(lastHeartbeat: string | null, stale: boolean): string {
  if (lastHeartbeat === null) return 'Not reported'
  return stale ? `${lastHeartbeat} (stale)` : lastHeartbeat
}

export function observedGenerationLabel(generation: number | null): string {
  return generation === null ? 'Not reported' : String(generation)
}

export function runtimeObservationDescription(engine: SipEngineOverview['engine']): string {
  if (!engine.registryPresent) return 'No registered engine observation is available.'
  if (engine.status === null && engine.lastHeartbeat === null) return 'A registry identity exists, but runtime status and heartbeat are not reported.'
  return 'Runtime observation is available when reported by the engine.'
}

export function appliedConfigurationLabel(): string {
  return 'Unknown / unconfirmed'
}

export function observedBootstrapLabel(
  bootstrap: SipEngineOverview['observed']['bootstrap'],
  stale: boolean,
): string {
  if (bootstrap === null) return 'Not reported'
  return stale
    ? `Last report: waiting for configuration (${bootstrap.reasonCode})`
    : `Needs configuration (${bootstrap.reasonCode})`
}
